import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import MoreIcon from "@material-ui/icons/MoreVert";
import Person from "../img/person.jpg";
import Icon from "@material-ui/core/Icon";
import TextField from "@material-ui/core/TextField";
import { messages } from "../data/messages";

export default class Chatbox extends Component {
	classes = {
		appBar: "makeStyles-appBar-299",
		button: "makeStyles-button-302",
		chatbox: "makeStyles-chatbox-303",
		fabButton: "makeStyles-fabButton-301",
		grow: "makeStyles-grow-300",
		list: "makeStyles-list-297",
		paper: "makeStyles-paper-296",
		subheader: "makeStyles-subheader-298",
		text: "makeStyles-text-295",
	};

	state = {
		msg: "",
		msgs: [
			{
				id: 1,
				name: "Shakil",
				msg: "joined this meeting",
				person: "/static/images/avatar/5.jpg",
			},
			{
				id: 2,
				name: "User 1",
				msg: "joined this meeting",
				person: "/static/images/avatar/1.jpg",
			},
			{
				id: 3,
				name: "User 2",
				msg: "joined this meeting",
				person: "/static/images/avatar/2.jpg",
			},
		],
	};

	handleMsg = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	handleSend = () => {
		let newObj = {
			id: 5,
			name: "Admin",
			msg: this.state.msg,
			person: "/static/images/avatar/3.jpg",
		};

		this.setState({
			msgs: [...this.state.msgs, newObj],
			msg: "",
		});
	};

	render() {
		return (
			<div style={{ position: "relative", height: "100%" }}>
				<CssBaseline />
				{console.log(this.classes)}
				<AppBar
					position="absolute"
					color="primary"
					className={this.classes.appBar}
				>
					<Toolbar>
						<Typography className={this.classes.title} variant="h6" noWrap>
							Live Chat
						</Typography>
					</Toolbar>
				</AppBar>
				<Paper
					square
					className={this.classes.paper}
					style={{ padding: 15, height: "calc(100vh - 167px)" }}
				>
					<Typography className={this.classes.text} variant="h5" gutterBottom>
						Inbox
					</Typography>
					<List
						className={(this.classes.list, "mt-4")}
						style={{ overflowY: "scroll", height: "340px" }}
					>
						{this.state.msgs.map(({ id, name, msg }) => (
							<React.Fragment key={id}>
								<ListItem
									button
									style={{ paddingTop: 5, paddingBottom: 5, paddingLeft: 0 }}
								>
									<ListItemAvatar>
										<Avatar alt="Profile Picture" src={Person} />
									</ListItemAvatar>
									<ListItemText primary={name} secondary={msg} />
								</ListItem>
							</React.Fragment>
						))}
					</List>
					<div
						className={this.classes.chatbox}
						style={{ position: "absolute", bottom: "11px", width: "91%" }}
					>
						<form
							className={this.classes.container}
							noValidate
							autoComplete="off"
							style={{ display: "flex", alignItems: "center" }}
						>
							<TextField
								id="standard-full-width"
								style={{ margin: 8, flex: 1 }}
								placeholder="Say something"
								fullWidth
								margin="normal"
								InputLabelProps={{
									shrink: true,
								}}
								name="msg"
								onChange={this.handleMsg}
								value={this.state.msg}
							/>
							<Button
								variant="contained"
								color="primary"
								className={this.classes.button}
								onClick={this.handleSend}
								endIcon={<Icon>send</Icon>}
							></Button>
						</form>
					</div>
				</Paper>
			</div>
		);
	}
}
